export function GetUniqueObjects<T>(arr: readonly T[], comp: keyof T): T[] {
  let obj: { [index: string]: T } = {};

  arr.forEach((val) => {
    obj[`${val[comp]}`] = val;
  });

  return Object.keys(obj).map((key) => obj[key]);
}
